/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import env from "./env";

export const environment = {
  production: false,
  API_HOST: env.devRequestUrl,
  tokenTypeBearer: env.tokenTypeBearer,
  API_KEY: env.API_KEY,
  ID: env.ID,
  ID2: env.ID2,
  licenceID: env.licenceID,
  logo: env.logo,
  maxImageSize: env.maxImageSize,
  projectName: env.projectName,
  // G_API: "AIzaSyB5v5XrWeD21V2DR-U_c14z1GbhkX_1VlU",
  G_API: "AIzaSyBTqcLOI0L6A7_IWGs67nePVIb2rSc53Cg",
};
